import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'
import messages from './TopNavbar.json'
import store from './../../../../store.js'

export default {
  name: 'TopNavbar',

  i18n: messages,

  components: {
    Navbar,
    NavbarToggleButton,
  },

  data() {
    return {
      activeNotifications: false,
      showNavbar: false,
    }
  },

  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown() {
      this.activeNotifications = false
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize()
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar
    },
    deconnecterUtilisateur() {
      this.$eventHub.$emit(this.$eventHub.SEND_LOG, 'DECONNEXION', null)
      store.commit('authReset')
      this.$router.push({ name: 'Login' })
    },

    /**
     * Remplace les variables du breadcrumb
     */
    replaceRouteParam(route) {
      if (route && route.includes(':structureNom')) {
        let structure = JSON.parse(localStorage.getItem('selectedStructure'))
        if (structure) {
          route = route.replace(':structureNom', structure.nom)
        } else {
          console.error('Valeur attendue dans le localStorage : selectedStructure')
        }
      }
      if (route && route.includes(':structureId')) {
        let structure = JSON.parse(localStorage.getItem('selectedStructure'))
        if (structure) {
          route = route.replace(':structureId', structure.id)
        } else {
          console.error('Valeur attendue dans le localStorage : selectedStructure')
        }
      }
      if (route && route.includes(':userNom')) {
        let user = JSON.parse(localStorage.getItem('selectedUser'))
        if (user) {
          route = route.replace(':userNom', user.nom)
        } else {
          console.error('Valeur attendue dans le localStorage : selectedUser')
        }
      }
      return route
    },
  },
}
